import { useContext } from 'react';
import { createContext } from 'react';

import { NewsletterCheckboxConfirmationProps } from '../@types/NewsletterCheckboxConfirmationProps';

export const NewsletterCheckboxConfirmationContext = createContext<NewsletterCheckboxConfirmationProps>(
	{} as NewsletterCheckboxConfirmationProps,
);

NewsletterCheckboxConfirmationContext.displayName = 'NewsletterCheckboxConfirmation';

const NewsletterCheckboxConfirmationProvider = (props: NewsletterCheckboxConfirmationProps) => (
	<NewsletterCheckboxConfirmationContext.Provider value={props}>
		{props.children}
	</NewsletterCheckboxConfirmationContext.Provider>
);

export const useNewsletterCheckboxConfirmation = () => {
	const context = useContext(NewsletterCheckboxConfirmationContext);

	return context;
};

export default NewsletterCheckboxConfirmationProvider;
